'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _index = require('../../utils/index');

var _index2 = _interopRequireDefault(_index);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _proGalleryLayouter = require('pro-gallery-layouter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryGroup = function () {
  function GalleryGroup(config) {
    (0, _classCallCheck3.default)(this, GalleryGroup);


    this.uniqueId = _index2.default.generateUUID();
    this.isGalleryGroup = true;

    if (config.dto && config.dto.dto) {
      config.dto = config.dto.dto; //defence patch due to mis-use of item-core
      if (_index2.default.isDev()) {
        console.warn('Item core is created with already existing item core');
      }
    }
    this.dto = _lodash2.default.merge({}, config.dto);
    _lodash2.default.merge(this, config.dto);

    if (config.scheme) {
      this.processScheme(config.scheme);
    } else {
      this.processScheme(new _proGalleryLayouter.Group({ dto: config.dto }).scheme);
    }

    if (config.items) {
      this.items = config.items;
    } else {
      console.warn('Pro Gallery created Gallery Group without items', config);
    }
  }

  (0, _createClass3.default)(GalleryGroup, [{
    key: 'processScheme',
    value: function processScheme(scheme) {
      this.id = scheme.id;
      this.idx = scheme.idx;
      this.width = scheme.width;
      this.height = scheme.height;
      this.totalHeight = scheme.totalHeight;
      this.ratio = scheme.ratio;
      this.top = scheme.top;
      this.left = scheme.left;
      this.right = scheme.right;
      this.bottom = scheme.bottom;
      this.visible = scheme.visible;
      this.rendered = scheme.rendered;
      this.required = scheme.required;
    }
  }, {
    key: 'renderProps',
    value: function renderProps(galleryConfig) {

      return {
        className: 'group',
        id: this.id,
        idx: this.idx,
        key: this.key,
        type: this.type,
        top: this.top,
        left: this.left,
        right: this.right,
        bottom: this.bottom,
        width: this.width,
        height: this.height,
        totalHeight: this.totalHeight,
        items: this.items,
        visible: this.visible,
        rendered: this.rendered,
        required: this.required,
        galleryConfig: galleryConfig
      };
    }
  }, {
    key: 'key',
    get: function get() {
      return 'group_' + this.id;
    }
  }]);
  return GalleryGroup;
}();

/*
 <img onLoad={() => this.setItemLoaded()} className={'image' + (this.state.loaded ? '' : '-preload')}
 src={this.props.resized_url}/>
 */

////// <reference path="../../reference.ts" />


exports.default = GalleryGroup;